module.exports = "/fonts/opensanssemibolditalic.ttf";